import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { profile } from "../data/portfolio";

const links = [
  { label: "Work", href: "#work" },
  { label: "Skills", href: "#skills" },
  { label: "Experience", href: "#experience" },
  { label: "Contact", href: "#contact" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#f4f4f0]/80 backdrop-blur-xl border-b border-black/10"
          : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <nav className="container-portfolio flex h-16 items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3 group"
          data-testid="nav-logo"
        >
          <span className="block h-2.5 w-2.5 rounded-full bg-[#FF3B30] transition-transform group-hover:scale-125" />
          <span className="text-sm font-bold tracking-tight">
            {profile.firstName}&nbsp;{profile.lastName}
            <span className="ml-2 font-light text-black/50">— Designer</span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="text-sm font-medium tracking-tight text-black/70 hover:text-black transition-colors relative after:absolute after:inset-x-0 after:-bottom-1 after:h-px after:bg-black after:scale-x-0 hover:after:scale-x-100 after:origin-left after:transition-transform"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contact"
          className="inline-flex items-center gap-2 bg-black text-[#f4f4f0] text-sm font-medium px-4 py-2 hover:bg-[#FF3B30] transition-colors"
          data-testid="nav-cta-contact"
        >
          Start a project
          <span aria-hidden>→</span>
        </a>
      </nav>
    </motion.header>
  );
};

export default Navigation;
